import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '@/components/HomePage'
import ProjectsPage from '@/components/ProjectsPage'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: HomePage
    },
    {
      path: '/projects',
      name: 'ProjectsPage',
      component: ProjectsPage
    },
    {
      path: '/projects/:id',
      name: 'ProjectDetails',
      component: ProjectsPage
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js